import { CloseSharp } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";

const CartConfirmation = ({
  openCartConfirm,
  setOpenCartConfirm,
  selectedService,
  addFunction,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  //Functions
  function handleClose() {
    setOpenCartConfirm(false);
  }

  //APIs
  const deleteCart = async () => {
    try {
      const response = await global.$axios.get(
        `cart/clear/${global.$userData.id}`
      );
      if (response.data.status === "success") {
        addFunction(selectedService);
        handleClose();
      } else {
        console.log("Delete Cart Issue", response.data);
      }
    } catch (error) {
      console.log("Delete Cart Issue", error);
    }
  };
  return (
    <Dialog
      fullScreen={fullScreen}
      open={openCartConfirm}
      fullWidth={true}
      maxWidth={"sm"}
      aria-labelledby="draggable-dialog-title"
      onClose={handleClose}
    >
      <Grid sx={{ py: 2, px: 3 }}>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <DialogTitle>
            <Typography sx={{ p: 0, color: "#071CB7", fontWeight: 600 }}>
              Replace Cart Item?
            </Typography>
          </DialogTitle>
          <IconButton sx={{ p: 0 }} onClick={handleClose}>
            <CloseSharp sx={{ color: "red" }} />
          </IconButton>
        </Grid>

        <DialogContent sx={{ px: { sm: 5, xs: 0 } }}>
          <Grid>
            <Typography sx={{ textAlign: "center" }}>
              Your cart contains other type of services. Do you want to discard
              the selection and add this services
            </Typography>
            <Grid
              sx={{
                justifyContent: "space-around",
                alignItems: "center",
                mt: 5,
              }}
              container
            >
              <Button
                onClick={handleClose}
                sx={{
                  textTransform: "capitalize",
                  background: "#CCD0FF",
                  color: "#000",
                  width: "20%",
                }}
                variant="contained"
                size="small"
              >
                No
              </Button>
              <Button
                onClick={deleteCart}
                sx={{
                  textTransform: "capitalize",
                  background: "#071CB7",
                  width: "20%",
                }}
                variant="contained"
                size="small"
              >
                Replace
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Grid>
    </Dialog>
  );
};

export default CartConfirmation;
